import React, { useEffect } from 'react';
import SEO from '../SEO';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import LegalNavigation from '../LegalNavigation';

const MentionsLegales = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="Mentions Légales"
        description="Mentions légales du site SISENS - Informations juridiques et légales concernant notre société de restauration collective."
        keywords="mentions légales, SISENS, informations juridiques, société restauration"
        url="https://sisens.eu/mentions-legales"
      />
      {/* Navigation bar */}
      <LegalNavigation />
      
      <div className="pt-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        {/* Bouton retour */}
        <div className="mb-8">
          <Link 
            to="/"
            className="inline-flex items-center text-[#4b9fcc] hover:text-[#e71f74] transition-colors duration-300"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour à l'accueil
          </Link>
        </div>

        {/* Contenu des mentions légales */}
        <div className="prose prose-lg max-w-none">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
            🧾 Mentions légales
          </h1>
          <p className="text-sm text-gray-600 mb-8 italic">
            (Mise à jour le 8 octobre 2025)
          </p>

          {/* Section 1 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-[#4b9fcc]">
              1. Éditeur du site
            </h2>
            <p className="mb-4">
              Le présent site internet, accessible à l'adresse <span className="font-semibold">https://www.sisens.eu</span>, est édité par :
            </p>
            <div className="bg-gray-50 p-4 rounded-lg mb-4">
              <p className="font-bold text-lg text-gray-900">SISENS</p>
              <p>Société par actions simplifiée (SAS)</p>
              <p>Au capital social de 6 000 €</p>
              <p>Immatriculée au Registre du Commerce et des Sociétés de Lyon sous le numéro <span className="font-semibold">912 406 345</span></p>
              <p>Code APE : <span className="font-semibold">5629A – Restauration collective sous contrat</span></p>
              <p>Siège social : <span className="font-semibold">36 Allée des Prés Rouets, 69510 Messimy, France</span></p>
              <p>Numéro SIRET : <span className="font-semibold">912 406 345 00013</span></p>
              <p>Adresse e-mail : <a href="mailto:contact@sisens.eu" className="text-[#4b9fcc] hover:text-[#e71f74]">contact@sisens.eu</a></p>
            </div>
            <div>
              <p className="font-semibold mb-2">Directeurs de la publication :</p>
              <ul className="list-disc list-inside ml-4">
                <li>Laurent KELMANOWITZ</li>
                <li>Christophe GARNIER</li>
              </ul>
            </div>
          </section>

          {/* Section 2 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-[#4b9fcc]">
              2. Propriété intellectuelle
            </h2>
            <p className="mb-4">
              L'ensemble des éléments composant le site <span className="font-semibold">https://www.sisens.eu</span> (textes, images, graphismes, logos, vidéos, icônes, sons, logiciels, structure du site, etc.) sont la propriété exclusive de SISENS, sauf mention contraire explicite.
            </p>
            <p className="mb-4">
              Toute reproduction, représentation, modification, publication, adaptation de tout ou partie du contenu du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de SISENS.
            </p>
            <p>
              Toute exploitation non autorisée du site ou de l'un quelconque de ses éléments sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles L.335-2 et suivants du Code de la propriété intellectuelle.
            </p>
          </section>

          {/* Section 3 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-[#4b9fcc]">
              3. Données personnelles (RGPD)
            </h2>
            <p className="mb-4">
              SISENS s'engage à ce que la collecte et le traitement des données à caractère personnel effectués à partir du site <span className="font-semibold">https://www.sisens.eu</span> soient conformes au Règlement (UE) 2016/679 du 27 avril 2016 (RGPD) et à la loi "Informatique et Libertés" du 6 janvier 1978 modifiée.
            </p>
            <p className="mb-4">
              Les données collectées via les formulaires du site (formulaire de contact, candidature, etc.) sont utilisées uniquement pour répondre aux demandes des utilisateurs et ne sont jamais transmises à des tiers sans consentement.
            </p>
            <div className="bg-blue-50 p-4 rounded-lg mb-4">
              <h3 className="font-semibold text-[#4b9fcc] mb-3">Vos droits :</h3>
              <p className="mb-2">Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>Droit d'accès à vos données personnelles,</li>
                <li>Droit de rectification ou d'effacement,</li>
                <li>Droit d'opposition ou de limitation du traitement,</li>
                <li>Droit à la portabilité de vos données.</li>
              </ul>
            </div>
            <p className="mb-4">
              Pour exercer ces droits ou toute question relative à la gestion de vos données, vous pouvez contacter :<br />
              📧 <a href="mailto:contact@sisens.eu" className="text-[#4b9fcc] hover:text-[#e71f74] font-semibold">contact@sisens.eu</a>
            </p>
            <p>
              Les données sont conservées pour la durée strictement nécessaire à la finalité pour laquelle elles ont été collectées.
            </p>
          </section>

          {/* Section 4 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-[#4b9fcc]">
              4. Cookies
            </h2>
            <p className="mb-4">
              Lors de la consultation du site, des cookies peuvent être déposés sur votre terminal à des fins de mesure d'audience ou d'amélioration de l'expérience utilisateur.
            </p>
            <div className="mb-4">
              <p className="mb-2">Vous pouvez à tout moment :</p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>Accepter ou refuser les cookies via le bandeau prévu à cet effet,</li>
                <li>Configurer votre navigateur pour bloquer certains cookies.</li>
              </ul>
            </div>
            <p>
              Pour plus d'informations, consultez la section dédiée "Gestion des cookies" accessible sur le site.
            </p>
          </section>

          {/* Section 5 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-[#4b9fcc]">
              5. Responsabilité
            </h2>
            <p className="mb-4">
              SISENS s'efforce de fournir sur son site des informations exactes et à jour. Toutefois, la société ne saurait être tenue responsable des omissions, inexactitudes ou carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires.
            </p>
            <p>
              Le site peut contenir des liens vers d'autres sites internet. SISENS n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou leur politique de confidentialité.
            </p>
          </section>

          {/* Section 6 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-[#4b9fcc]">
              6. Hébergement
            </h2>
            <p className="mb-4">
              Le site <span className="font-semibold">https://www.sisens.eu</span> est hébergé par :
            </p>
            <div className="bg-gray-50 p-4 rounded-lg mb-4">
              <p className="font-bold text-lg text-gray-900">Sharpheberg</p>
              <p>Hébergeur web professionnel</p>
              <p>Site web : <a href="https://sharpheberg.com/" target="_blank" rel="noopener noreferrer" className="text-[#4b9fcc] hover:text-[#e71f74] font-semibold underline">https://sharpheberg.com/</a></p>
            </div>
          </section>

          {/* Section 7 */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-[#4b9fcc]">
              7. Droit applicable
            </h2>
            <p className="mb-4">
              Le présent site et ses mentions légales sont régis par le droit français.
            </p>
            <p>
              Tout litige relatif à l'utilisation du site <span className="font-semibold">https://www.sisens.eu</span> relève de la compétence exclusive des tribunaux français.
            </p>
          </section>
        </div>
      </div>
      </div>
    </div>
  );
};

export default MentionsLegales;